/**
 * Hotel Hub SDK 入口
 *
 * 同源宿主渲染:暴露 window.HotelSDK 全局 + 注册 <hotel-date-bar> / <hotel-book-bar> / <hotel-package-list> / <hotel-customer-service> Web Component。
 * 阶段3:datebar 组件内部由 React 在 Shadow DOM 渲染,React 打进 bundle。
 * 客服挂件:纯副作用(注入 widget.js + identify),无 UI,不挂 Shadow DOM,默认自动挂载。
 *
 * 构建为 IIFE(esbuild globalName=HotelSDK)。用命名导出(非 default),
 * 使 esbuild 暴露的 window.HotelSDK 命名空间直接可用(window.HotelSDK.createDateBar),
 * 不被包成 {default:...}(参考旧 iframe 路线 tsup IIFE 同样处理)。
 */
import { setConfig } from './config';
import { onReady, markReady } from './ready';
import { createDateBar, createBookBar, createPackageList } from './date-bar/imperative';
import { registerDateBar, registerBookBar, registerPackageList } from './date-bar/component';
import { onUnauthorized } from './api/client';
import { registerCustomerService } from './customer-service/component';
import { createCustomerService } from './customer-service/imperative';
import { autoMountCustomerService } from './customer-service/widget';
import { VERSION } from './version';

// 副作用:注册 Web Component + 标记就绪并 flush ready 队列 + 自动挂载客服
// (window.HotelSDK 由 esbuild globalName 暴露命名导出,见 scripts/build-sdk.mjs)
if (typeof window !== 'undefined') {
  registerDateBar();
  registerBookBar();
  registerPackageList();
  registerCustomerService();

  // hotel-hub.js 用 <script defer> 引入,运行时 readyState 通常为 interactive/complete;
  // 兜底 loading 态(非 defer / head 引入场景)等 DOMContentLoaded。
  // 先 markReady(flush ready 队列,接入方 HotelSDK.ready 回调可能在此主动 createCustomerService),
  // 再 autoMountCustomerService(检测 currentHandle/标签跳过,命令式与显式标签优先)。
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          markReady();
          void autoMountCustomerService();
        },
        { once: true }
      );
    } else {
      markReady();
      void autoMountCustomerService();
    }
  }
}

export const version = VERSION;
export { setConfig as config };
export { onReady as ready };
export { createDateBar, createBookBar, createPackageList };
export { onUnauthorized };
export { createCustomerService };
